import { z } from 'zod';

/**
 * Runtimevalidatie van het templatepakket. Het pakket is onveranderlijk en
 * wordt één keer per versie opgehaald, dus het parsen mag wat kosten — maar
 * `buildGraph()` doet het bewust *niet*: valideer aan de netwerkrand, reken
 * daarna zonder controles.
 */

const conditionResultCodeSchema = z.union([
    z.literal(-5),
    z.literal(-4),
    z.literal(-3),
    z.literal(-2),
    z.literal(-1),
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(4),
    z.literal(6),
    z.literal(8),
]);

const questionTypeSchema = z.enum([
    'options',
    'options_single_multi',
    'options_multi',
    'yes_no',
    'number',
    'text',
    'text_items',
]);

const questionOptionSchema = z.object({
    id: z.number().int(),
    legacy_id: z.number().int().nullable(),
    label: z.string(),
    sort_order: z.number().int(),
    is_exclusive: z.boolean(),
});

const questionSchema = z.object({
    id: z.number().int(),
    legacy_id: z.number().int().nullable(),
    type: questionTypeSchema,
    label: z.string(),
    help_text: z.string().nullable(),
    photo_requirement: z.enum(['none', 'optional', 'required']),
    photo_min: z.number().int().nullable(),
    number_min: z.number().nullable(),
    number_max: z.number().nullable(),
    number_unit: z.string().nullable(),
    number_decimals: z.number().int().nullable(),
    special: z.enum(['none', 'build_year']),
    ask_once: z.boolean(),
    sort_order: z.number().int(),
    options: z.array(questionOptionSchema),
});

const nodeItemOptionSchema = z.object({
    id: z.number().int(),
    question_option_id: z.number().int(),
    result: conditionResultCodeSchema.nullable(),
    next_item_id: z.number().int().nullable(),
    report_text: z.string().nullable(),
    direct_cost: z.string(),
    term_cost: z.string(),
    improvement_cost: z.string(),
    cost_group_id: z.number().int().nullable(),
    is_clean: z.boolean(),
    sort_order: z.number().int(),
    amount_prompt: z.enum(['direct', 'term', 'improvement']).nullable().optional(),
});

const nodeItemSchema = z.object({
    id: z.number().int(),
    legacy_id: z.number().int().nullable(),
    question_id: z.number().int(),
    is_start: z.boolean(),
    sort_order: z.number().int(),
    options: z.array(nodeItemOptionSchema),
});

const nodeSchema = z.object({
    id: z.number().int(),
    parent_id: z.number().int().nullable(),
    legacy_id: z.number().int().nullable(),
    name: z.string(),
    sort_order: z.number().int(),
    nhg_code: z.string().nullable(),
    is_multi: z.boolean(),
    multi_question_label: z.string().nullable(),
    multi_instance_label: z.string().nullable(),
    multi_report_text: z.string().nullable(),
    in_report_by_default: z.boolean(),
    items: z.array(nodeItemSchema),
});

const costGroupSchema = z.object({
    id: z.number().int(),
    code: z.string().nullable(),
    name: z.string(),
    long_name: z.string().nullable(),
    sort_order: z.number().int(),
});

export const templatePackageSchema = z.object({
    template_version_id: z.number().int(),
    template_id: z.number().int(),
    version: z.number().int(),
    name: z.string(),
    inspection_type: z.string(),
    checksum: z.string(),
    generated_at: z.string(),
    cost_groups: z.array(costGroupSchema),
    questions: z.array(questionSchema),
    nodes: z.array(nodeSchema),
});
